import { Alert } from '@mui/material';

interface DataLoadingNoticeProps {
  /** Human label for the data set, e.g. "SSCC" or "Trip sheet". */
  label: string;
  /** Optional override message. */
  message?: string;
}

export default function DataLoadingNotice({ label, message }: DataLoadingNoticeProps) {
  return (
    <Alert severity="info" role="status">
      {message ?? `${label} data is still loading in the background. It will be available shortly.`}
    </Alert>
  );
}
